import { SUBMIT_URL, API_KEY } from 'client/site-modules/core-page/constants/crowdsourced-deals';
import { logger } from 'client/utils/logger/logger';

const ZERO_PERCENT_OFF_VISIBLE_VALUE = -0.222;
const ZERO_VALUE_DEALERS_COUNT = 12;

export const getFormattedChartData = dealers => {
  let zeroValueDealers = 0;

  return (
    dealers
      .reduce((acc, dealer) => {
        // limit number of zero percent dealers to `ZERO_VALUE_DEALERS_COUNT`
        if (dealer.finalPercentOffMsrp || zeroValueDealers !== ZERO_VALUE_DEALERS_COUNT) {
          if (dealer.finalPercentOffMsrp === 0) zeroValueDealers += 1;

          acc.push(dealer);
        }

        return acc;
      }, [])
      .map(({ dealerName, dealerFranchiseId, finalPercentOffMsrp }) => ({
        dealerName,
        dealerFranchiseId,
        finalPercentOffMsrp: finalPercentOffMsrp === 0 ? ZERO_PERCENT_OFF_VISIBLE_VALUE : finalPercentOffMsrp,
      }))
      // reverse to display higher values on the right side
      .reverse()
  );
};

export const tickFormatter = value => `${value}%`;

export const getSavings = (csdPercentOff, defaultMsrp) => ({
  min: (csdPercentOff?.minFinalPercentOffMSrp / 100) * defaultMsrp,
  max: (csdPercentOff?.maxFinalPercentOffMsrp / 100) * defaultMsrp,
});

export const isFormValid = (fields, errors) =>
  Object.keys(fields).every(field => fields[field].value() && !(field in errors));

export const submitForm = data =>
  fetch(SUBMIT_URL, {
    method: 'POST',
    retries: 0,
    headers: {
      'content-type': 'application/json',
      'x-api-key': API_KEY,
    },
    body: JSON.stringify(data),
  })
    .then(res => res)
    .catch(e => logger.error(e));
